<template>
    <section v-if="post" class="tp-section">
        <header class="tp-section-head">
            <i class="fal fa-info-circle tp-section-ic"></i>
            <h3 class="tp-section-title">
                {{ $t('post.page.information.general') }}
            </h3>
        </header>

        <div class="tp-section-body">
            <div v-if="post.content" class="tp-field">
                <span class="tp-field-label">
                    {{ $t('post.page.preview.description') }}
                </span>
                <div class="tp-field-rich" v-html="post.content"></div>
            </div>

            <dl class="tp-meta">
                <div v-if="post.created_at" class="tp-meta-row">
                    <dt class="tp-meta-label">
                        <i class="far fa-calendar-alt"></i>
                        {{ $t('post.page.preview.created_at') }}
                    </dt>
                    <dd class="tp-meta-value">
                        {{ formatDate(post.created_at) }}
                    </dd>
                </div>

                <div v-if="post.updated_at" class="tp-meta-row">
                    <dt class="tp-meta-label">
                        <i class="far fa-history"></i>
                        {{ $t('post.page.preview.edited_at') }}
                    </dt>
                    <dd class="tp-meta-value">
                        {{ formatDate(post.updated_at) }}
                    </dd>
                </div>

                <div v-if="post.form && post.form.name" class="tp-meta-row">
                    <dt class="tp-meta-label">
                        <i class="far fa-file-alt"></i>
                        {{ $t('post.page.preview.form_name') }}
                    </dt>
                    <dd class="tp-meta-value">{{ post.form.name }}</dd>
                </div>

                <div v-if="ownerLabel" class="tp-meta-row">
                    <dt class="tp-meta-label">
                        <i class="far fa-user"></i>
                        {{ $t('post.page.preview.owner') }}
                    </dt>
                    <dd class="tp-meta-value">{{ ownerLabel }}</dd>
                </div>
            </dl>
        </div>
    </section>
</template>

<script>
export default {
    name: 'PostPreviewInfo',
    props: ['post'],
    computed: {
        ownerLabel() {
            const owner = this.post && this.post.created_by
            if (!owner) return null
            return owner.name || owner.email || null
        }
    },
    methods: {
        formatDate(value) {
            return this.moment(value)
                .locale(this.$store.state.lang)
                .format('Do MMMM YYYY')
        }
    }
}
</script>

<style scoped>
.tp-section {
    background: var(--v2-surface-0, #fff);
    border: 1px solid var(--v2-border, #e2e8f0);
    border-radius: 12px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    overflow: hidden;
}

.tp-section-head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    border-bottom: 1px solid var(--v2-border-subtle, #f1f5f9);
    background: var(--v2-surface-1, #f8fafc);
}

.tp-section-ic {
    color: var(--v2-primary, #0891b2);
    font-size: 0.9rem;
}

.tp-section-title {
    margin: 0;
    font-size: 0.8125rem;
    font-weight: 600;
    color: var(--v2-text-1, #0f172a);
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.tp-section-body {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.tp-field {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.tp-field-label {
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--v2-text-3, #64748b);
}

.tp-field-rich {
    font-size: 0.875rem;
    line-height: 1.5;
    color: var(--v2-text-2, #334155);
}

.tp-field-rich >>> p {
    margin: 0 0 6px;
}

.tp-field-rich >>> p:last-child {
    margin-bottom: 0;
}

.tp-meta {
    margin: 0;
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
}

.tp-meta-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 8px 0;
    border-top: 1px dashed var(--v2-border-subtle, #f1f5f9);
}

.tp-meta-row:first-child {
    border-top: 0;
    padding-top: 0;
}

.tp-meta-label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    font-size: 0.75rem;
    font-weight: 500;
    color: var(--v2-text-3, #64748b);
}

.tp-meta-label i {
    color: var(--v2-primary, #0891b2);
    font-size: 0.75rem;
}

.tp-meta-value {
    margin: 0;
    font-size: 0.8125rem;
    font-weight: 500;
    color: var(--v2-text-1, #0f172a);
    text-align: right;
    word-break: break-word;
}
</style>
